module.exports = __webpack_public_path__ + "media/3_6-11.3a66b988.mp3";